import Title from './Title'
import Navbar from './Navbar'

const Header = () =>
  <div className="flex justify-between px-4 py-3">
    <Title />
    <Navbar />
  </div>


export default Header
